<template>
  <div>
    <el-menu
        :default-active="active_item"
        class="el-menu-vertical-demo"
        :collapse="false"
        @open="handleOpen"
        @close="handleClose">
      <el-submenu v-if="sysAdmin" index="0">
        <template slot="title">
          <i class="el-icon-monitor"></i>
          <span>系统管理</span>
        </template>
        <el-menu-item index="udb" @click="go_to('/#/sys/udb')">用户搜索</el-menu-item>
        <el-menu-item index="users" @click="go_to('/#/sys/users')">用户管理</el-menu-item>
        <el-menu-item index="log" @click="go_to('/#/sys/log')">日志查询</el-menu-item>
        <el-menu-item index="spend" @click="go_to('/#/user/spend')">消费记录</el-menu-item>
      </el-submenu>
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-school"></i>
          <span>数据中心</span>
        </template>
        <el-menu-item index="export" @click="go_to('/#/user/export')">报告&导出</el-menu-item>
      </el-submenu>
      <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-menu"></i>
          <span slot="title">交易管理</span>
        </template>
        <el-menu-item index="charge" @click="go_to('/#/user/charge')">账户充值</el-menu-item>
      </el-submenu>
      <el-submenu index="4">
        <template slot="title">
          <i class="el-icon-setting"></i>
          <span slot="title">账户设置</span>
        </template>
        <el-menu-item index="setting" @click="go_to('/#/user/setting')">账户信息</el-menu-item>
        <el-menu-item index="password" @click="go_to('/#/user/password')">修改密码</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
import api from '../api/rest'

export default {
  props: {
    active_item: '',
    form: {}
  },
  data() {
    return {
      sysAdmin: false,
      admin: false,
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    go_to(url) {
      window.location = url
    }
  },
  mounted() {
    var user = api.storage.get('user')
    if (user != null) {
      let roles = api.storage.get('user').roles
      if (roles.indexOf('ADMIN') != -1)
        this.admin = true
      if (roles.indexOf('SYSADMIN') != -1) {
        this.sysAdmin = true
      }
    }
  }
}

</script>

<style scoped>

.el-menu-item a {
  text-decoration: none;
  color: #303133;
}

.el-menu-item.is-active {
  background-color: #ecf5ff;
}

.el-menu {
  border-right: 0px;
}

</style>


// WEBPACK FOOTER //
// HomeSidebar.vue?14c76b48